import React from 'react';
import { Routes, Route } from 'react-router-dom';
import RequireGameAuth from '../../shared/components/RequireGameAuth';
import Layout from '../../shared/components/Layout';
import Sidebar from '../../shared/components/Sidebar';
import HomePage from './pages/HomePage';
import LevelsPage from './pages/LevelsPage';
import { auth } from './firebase';
import navItems from './nav';
import './theme.css';

const JellyApp = () => (
  <div className="game-jelly">
    <RequireGameAuth
      auth={auth}
      title="🍬 Jelly Match Admin"
      errorMessage="Đăng nhập thất bại. Kiểm tra lại email/mật khẩu."
      busyLabel="Đang đăng nhập..."
      footnote="Tài khoản admin được tạo trong Firebase Console → Authentication → Users (project jelliq-game)."
    >
      {(user) => (
        <Layout
          title="Jelly Match Admin"
          renderSidebar={({ isOpen, closeSidebar }) => (
            <Sidebar
              auth={auth}
              brandLabel="🍬 Jelly Match"
              navItems={navItems}
              isOpen={isOpen}
              closeSidebar={closeSidebar}
              userEmail={user?.email}
            />
          )}
        >
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/levels" element={<LevelsPage />} />
          </Routes>
        </Layout>
      )}
    </RequireGameAuth>
  </div>
);

export default JellyApp;
